/**
 * Tests if an element has overflown its contents
 *
 * https://stackoverflow.com/a/9541579
 **/
export const testHasOverflownLines = (
  element: HTMLElement,
  maxHeight?: number,
) => {
  if (!maxHeight) return false;
  return element.scrollHeight > maxHeight;
};
